import classnames from 'classnames/bind'
import React from 'react'

import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceholder from '~/components/ImageWithPlaceholder'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface BulletStepProps {
  className?: string
  index?: number
  colorStart?: string
  image?: ImageProps
  title?: RichTextBlock[]
  text?: RichTextBlock[]
}

function BulletStep({
  className,
  colorStart,
  image,
  title,
  text,
  index,
}: BulletStepProps) {
  const titleStyle = useStyle({ textPreset: 'title-content-section' })
  const textStyle = useStyle({
    textPreset: 'text-paragraph',
    color: 'cornflower-blue',
  })

  return (
    <div className={cx(css.BulletStep, className)}>
      <div className={css.content}>
        <div
          className={css.contentLeft}
          style={{
            backgroundColor: colorStart,
          }}>
          <div
            className={cx(css.number, titleStyle)}
            style={{
              color: colorStart,
              borderColor: colorStart,
            }}>
            {index + 1}
          </div>
          <div className={css.imageWrapper}>
            {image && (
              <ImageWithPlaceholder
                layout="fill"
                objectFit="contain"
                {...image}
              />
            )}
          </div>
        </div>
        <div className={css.contentRight}>
          {title && (
            <RichText
              className={cx(css.title, titleStyle)}
              style={{
                color: colorStart,
              }}
              render={title}
            />
          )}
          {text && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
        </div>
      </div>
    </div>
  )
}

BulletStep.defaultProps = {}

export default BulletStep
